export default __webpack_public_path__ + "static/media/ig-gradient-plan-pack-small-business.05c54a0c.webp";